<template>
  <div class="rm-screen rm-gm">
    <div v-if="loading && !rows.length" class="rm-empty">
      <v-progress-circular indeterminate color="#c2410c"></v-progress-circular>
    </div>

    <template v-else>
      <div v-if="companies.length" class="rm-summary">
        <div class="rm-summary__row">
          <div class="rm-summary__labels">
            <span>{{ $t("taken") }}</span>
            <span>{{ pluralT("report_mobile.companies_n", companies.length) }}</span>
          </div>
          <span class="rm-summary__value">
            {{ summary.taken }}<span class="rm-summary__value-of"> / {{ summary.ordered }}</span>
          </span>
        </div>
        <div
          class="rm-progress rm-progress--inverse"
          role="progressbar"
          :aria-valuenow="summary.taken"
          aria-valuemin="0"
          :aria-valuemax="summary.ordered"
        >
          <div class="rm-progress__fill" :style="{ width: `${summary.percent}%` }"></div>
        </div>
      </div>

      <article v-for="company in companies" :key="company.key" class="rm-card rm-taken-card">
        <div class="rm-taken-card__head">
          <div class="rm-taken-card__title">
            <h2 class="rm-taken-card__name">{{ company.name }}</h2>
            <span class="rm-badges rm-taken-card__badges">
              <span v-for="shift in company.shifts" :key="shift.id" class="rm-badge rm-num">
                {{ $t("report_mobile.shift_short", { n: shift.id }) }} · {{ shift.taken }} / {{ shift.ordered }}
              </span>
            </span>
          </div>
          <span class="rm-taken-card__value rm-num">
            {{ company.taken }}<span class="rm-taken-card__of"> / {{ company.ordered }}</span>
          </span>
        </div>
        <div
          class="rm-progress"
          :class="{ 'rm-progress--complete': company.complete }"
          role="progressbar"
          :aria-valuenow="company.taken"
          aria-valuemin="0"
          :aria-valuemax="company.ordered"
        >
          <div class="rm-progress__fill" :style="{ width: `${company.percent}%` }"></div>
        </div>
      </article>

      <div v-if="!companies.length" class="rm-empty">{{ emptyTitle }}</div>
    </template>
  </div>
</template>

<script>
import { SHIFTS } from "@/constants/shifts";
import hasPlural from "@/components/report/shared/hasPlural";
import { parseTaken, percentOf } from "@/components/report/shared/takenMath";
import "./guestMobileLists.scss";

/**
 * Preuzeto (gosti) na telefonu: ukupno preuzeto / poručeno i kartica po firmi sa smenama.
 * Ista svojstva kao GuestTakenView (računar); podatke daje ekran (stari tab).
 */
export default {
  name: "GuestMobileTakenView",
  mixins: [hasPlural],
  props: {
    rows: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    search: { type: String, default: "" },
  },
  computed: {
    companies() {
      const searched = this.customSearch(
        this.rows.map((item, index) => ({ ...item, key: index, menu: this.toLatin(item.menu || "") })),
        [{ value: "menu" }],
        this.search
      );
      return searched
        .map((item) => {
          const total = parseTaken(item.total);
          return {
            key: item.key,
            name: item.menu,
            taken: total.taken,
            ordered: total.ordered,
            complete: total.ordered > 0 && total.taken >= total.ordered,
            percent: percentOf(total.taken, total.ordered),
            shifts: SHIFTS.map((shift) => ({ id: shift.id, ...parseTaken(item[shift.key]) })).filter((shift) => shift.ordered > 0),
          };
        })
        .filter((company) => company.ordered > 0 || company.taken > 0);
    },
    summary() {
      const taken = this.companies.reduce((sum, company) => sum + company.taken, 0);
      const ordered = this.companies.reduce((sum, company) => sum + company.ordered, 0);
      return { taken, ordered, percent: percentOf(taken, ordered) };
    },
    emptyTitle() {
      return this.search ? this.$t("report_mobile.no_results_for", { search: this.search }) : this.$t("no_taken_meals_data");
    },
  },
};
</script>
